//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../../../components/ImageUploader";

export default {
    name: "page-dutyfeedback-popup",
    components: {ImageUploader},
    props: {
        value: Boolean,
        operatorId: {
            required: true
        }
    },
    data() {
        return {
            saving: false,
            saveDto: {
                id: 0,
                image: {
                    addAttrIds: [], delAttrIds: []
                }
            },
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        },
    },
    methods: {
        onCancel() {
            this.$emit('handleCancel')
        },
        onSuccess() {
            this.$emit('handleSuccess')
        },
        onSave() {
            this.saveDto.workOrderId = this.workOrderInfo.id;
            this.saveDto.operateId = this.operatorId;
            this.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/SaveDutyFeedbackRecord', this.saveDto).then(res => {
                this.onSuccess()
                this.onCancel()
            }).finally(() => {
                this.saving = false;
            })
        },
    },
    created() {
    }
}
